import Vue from 'vue';
import types from './mutation-types';

const mutations = {
  [types.SET_ACTIVE_EDITOR_LOCATION](state, editorLocation) {
    Vue.set(state, 'activeEditorLocation', editorLocation);
  },

  [types.SET_ACTIVE_EDITOR_ID](state, editorId) {
    Vue.set(state, 'activeEditorId', editorId);
  },

  [types.SET_PAGE_INDEX](state, pageIndex) {
    Vue.set(state, 'selectedPreviewPageIndex', pageIndex);
  },

  [types.SET_IS_STUDENT_PREVIEW](state, isStudentAssignmentPreview) {
    Vue.set(state, 'isStudentAssignmentPreview', isStudentAssignmentPreview);
  },

  [types.SET_IS_CLASS_PREVIEW](state, isClassAssignmentPreview) {
    Vue.set(state, 'isClassAssignmentPreview', isClassAssignmentPreview);
  },

  [types.SET_IS_PAGE_PREVIEW](state, isPagePreview) {
    Vue.set(state, 'isPagePreview', isPagePreview);
  },

  [types.SET_SELECTED](state, card) {
    Vue.set(state, 'selectedPreviewCard', card);
  },

  [types.SET_BUSY](state, obj) {
    Vue.set(state, 'busy', obj.busy);
  },
};

export default mutations;
